import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useExternalSettings from './useExternalSettings';
import { Creators as registrationTimesActions } from '@/domain/useCases/getRegistrationTimes';

const useCourseSchedules = () => {
  const dispatch = useDispatch();
  const academic = useSelector((state: any) => state.profile?.data?.academic);
  const { enrolmentPeriod } = useExternalSettings();
  const items = useSelector(
    (state: any) => state?.registrationTimes?.items || []
  );
  const [dataSchedules, setDataSchedules] = useState<Record<string, any>>({});
  const [isLoadingSchedules, setIsLoadingSchedules] = useState<
    Record<string, boolean>
  >({});

  useEffect(() => {
    if (Array.isArray(items)) {
      const updatedDataSchedules: Record<string, any> = {};
      const updatedIsLoadingSchedules: Record<string, boolean> = {};
      items.forEach((item) => {
        if (item?.isLoading) {
          updatedIsLoadingSchedules[item.id] = true;
        } else {
          updatedDataSchedules[item.id] = {
            schedules: item.data,
            needsUpdate: false
          };
          updatedIsLoadingSchedules[item.id] = false;
        }
      });
      // evitar actualizaciones innecesarias
      setDataSchedules((prev) => {
        const hasChanges = Object.keys(updatedDataSchedules).some(
          (key) =>
            !prev[key] ||
            JSON.stringify(prev[key]) !==
              JSON.stringify(updatedDataSchedules[key])
        );
        return hasChanges ? { ...prev, ...updatedDataSchedules } : prev;
      });
      setIsLoadingSchedules((prev) => {
        const hasChanges = Object.keys(updatedIsLoadingSchedules).some(
          (key) => prev[key] !== updatedIsLoadingSchedules[key]
        );
        return hasChanges ? { ...prev, ...updatedIsLoadingSchedules } : prev;
      });
    }
  }, [items]);

  const fetchSchedules = (courseId: string) => {
    setIsLoadingSchedules((prev) => ({ ...prev, [courseId]: true }));
    dispatch(
      registrationTimesActions.getRegistrationTimes(
        courseId,
        academic?.campus,
        academic?.career,
        academic?.plan,
        academic?.prog,
        enrolmentPeriod
      )
    );
  };

  const needsUpdate = (courseId: string) => {
    setDataSchedules((prev) => ({
      ...prev,
      [courseId]: { ...prev[courseId], needsUpdate: true }
    }));
  };

  const getSchedulesForCourse = (courseId: string) => {
    const schedules = dataSchedules[courseId]?.schedules || [];
    if (!schedules.length) return [];
    return schedules.slice().sort((a: any, b: any) => {
      const teacherA = (a?.teachers || []).sort().join(', ').toLowerCase();
      const teacherB = (b?.teachers || []).sort().join(', ').toLowerCase();
      return teacherA.localeCompare(teacherB);
    });
  };

  return {
    fetchSchedules,
    getSchedulesForCourse,
    isLoadingSchedules,
    needsUpdate
  };
};

export default useCourseSchedules;
